import * as React from 'react';
import InputComponent from './InputComponent';

interface IEmailState {
    hasError: boolean
    emailValue: string
}

interface IEmailProps {
    content: any
    validateInput(inputID: string, isCorrect: boolean): any
    onValueChange(input: string): void
}


class EmailInput extends React.Component<IEmailProps, IEmailState> {

    constructor(props: IEmailProps) {
        super(props);
        this.state = {
            hasError: false,
            emailValue: '',
        }

        this.handleError = this.handleError.bind(this)
        this.checkEmailRegex = this.checkEmailRegex.bind(this)
        this.changeInputValue = this.changeInputValue.bind(this)
        this.validateEmailInput = this.validateEmailInput.bind(this)
    }

    public changeInputValue(input: string): void {
        this.setState({
            emailValue: input
        }, () => {
            if (this.state.hasError) {
                this.handleError()
            } else {
                this.validateEmailInput()
            }
            this.props.onValueChange(input);
        })
    }
    public handleError(): void {
        if (this.state.emailValue.length && this.checkEmailRegex()) {
            this.setState({
                hasError: false
            }, () => {
                this.validateEmailInput()
            })
        } else if (!this.state.emailValue.length) {
            this.setState({
                hasError: false
            }, () => {
                this.validateEmailInput()
            })
        } else {
            this.setState({
                hasError: true
            })
        }
    }

    public checkEmailRegex(): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (emailRegex.test(this.state.emailValue)) {
            return true
        }
        return false
    }

    public validateEmailInput(): void {
        if (!this.state.hasError && this.state.emailValue.length) {
            if (this.checkEmailRegex()) {
                this.props.validateInput('email', true)
            } else {
                this.props.validateInput('email', false)
            }
        } else {
            this.props.validateInput('email', false)
        }
    }


    public render() {
        if (this.props.content === null) {
            return null
        }

        return (
            <InputComponent
                inputValue={this.state.emailValue}
                hasError={this.state.hasError}
                placeholder={this.props.content.emailInputLabel}
                errorMessage={this.props.content.emailInputError}
                maxLength={255}
                changeInputValue={this.changeInputValue}
                checkInput={this.handleError}
                type="email" />
        )
    }
}

export default EmailInput





// WEBPACK FOOTER //
// ./src/components/Inputs/EmailInput.tsx